<template>
  <div class="score-setting">
    <v-base-card>
      <template v-slot:heading>
        <div class="change-heading">
          <p class="change-heading__text mr-4">テスト作成</p>
          <p class="change-heading__text">配点・観点修正</p>
        </div>
      </template>

      <template v-slot:content>
        <v-section-panel useBreak>
          <template v-slot:content>
            <v-container class="py-0" fluid>
              <v-row>
                <v-col :cols="stepCols" class="py-0" v-resize="setStepCols">
                  <v-stepp :stepps="stepps" disabled/>
                </v-col>
              </v-row>
            </v-container>
            <v-container fluid>
              <v-row>
                <v-col cols=6>
                  <v-result-table/>
                </v-col>
                <v-col cols=6 class="pa-0">
                  <v-bar-charts/>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-section-panel>

        <v-section-panel useBreak>
          <template v-slot:content>


            <v-row class="mt-3 ml-4 mb-4">
              <v-chip
                color="secondary"
                text-color="white"
              >
                <v-icon left>mdi-text-box-check-outline</v-icon>
                合計点：{{totalScore}}点
              </v-chip>
            </v-row>
            <v-row class="ml-4">
              <p class="ma-0 attention"> ※配点や観点を変更したらリアルタイムで合計点やグラフの内容が変更されます。</p>
            </v-row>

            <v-card
              class="mx-2 mt-0"
              elevation="4"
            >
              <v-tabs
                v-model="tab"
                background-color="#346da6"
                dark
                show-arrows
              >
                <v-tab
                  v-for="(item,itemIndex) in usedItems"
                  :key="itemIndex+1"
                >
                  大問{{ itemIndex+1 }} [ {{selectContentScore(itemIndex).totalScore}}点 ]
                </v-tab>
              </v-tabs>

              <v-tabs-items
                v-model="tab"
              >
                <v-tab-item
                  v-for="(item, itemIndex) in usedItems"
                  :key="itemIndex+1"
                >
                  <v-container fluid>
                    <v-row>
                      <v-col cols=6 class="card mb-3">
                        <!-- 画像表示 -->
                        <v-img
                          class="white--text align-end"
                          :src="image"
                          v-for="(image, i) in selectedItem.questionImage"
                          :key="`image_${i}`"
                          max-height="900px"
                          contain
                        >
                        </v-img>
                      </v-col>
                      <v-col cols=6>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left pl-1 py-2 th_top">大問</th>
                                <th class="text-left pl-1 py-2 td_top">小問番号</th>
                                <th class="text-left pl-1 py-2 td_top">配点</th>
                                <th class="text-left pl-1 py-2 td_top">観点</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td :rowspan=item.sheetQuestions.length+1 class="part-num cotext-left pl-1 py-2">{{itemIndex+1}}</td>
                              </tr>
                              <tr v-for="(questionNo, questionIndex) in item.sheetQuestions.length" :key="'part-1-'+questionIndex">
                                <td class="text-left pl-1 py-2 question_no">{{createQuestionNo(item.sheetQuestions[questionIndex].question)}}</td>
                                <td class="text-left pl-1 py-2 score">
                                  <div class="score__area">
                                    <v-text-field
                                      @focus="setTargetQuestionIndex(questionIndex)"
                                      @input="updateScore($event)"
                                      :value="item.sheetQuestions[questionIndex].allot"
                                      outlined
                                      hide-details
                                      color="secondary"
                                      class="score__input"
                                      dense
                                      oninput="value = value.replace(/[^0-9^０-９]+/i,'');"
                                    ></v-text-field>
                                    <p
                                      class="score__question-cnt"
                                      v-if="item.sheetQuestions[questionIndex].question.question_cnt !== 1"
                                    >× {{item.sheetQuestions[questionIndex].question.question_cnt}}</p>
                                  </div>
                                </td>
                                <td class="text-left pl-1 py-1 viewpoint">
                                  <!-- ＠clickでクリックされたセレクトボックスから変更された小問を取得 -->
                                  <v-select
                                    @click="setTargetQuestionIndex(questionIndex)"
                                    @input="updatePointId($event)"
                                    :value="item.sheetQuestions[questionIndex].pointId"
                                    :items="viewPoints"
                                    item-text="name"
                                    item-value="id">
                                  </v-select>
                                </td>
                              </tr>
                              <tr>
                                <td colspan="2" class="text-left part-total pl-1 py-2">合計</td>
                                <td class="text-left pl-1 py-2">
                                  <p class="pb-0 mb-0 part-total__value">{{selectContentScore(itemIndex).totalScore}}</p>
                                </td>
                                <td/>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <div class="mb-3 ml-5 mt-3">
                          <p class="mb-0 attention-number-errors" style="color:red" v-for="(error, i) in numberErrors" :key="`n_e_${i}`"> {{error}}</p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <div :class="[valid ? 'mt-10' : 'mt-3']" class="buttons">
              <v-preview-buttons
                :previewImages="previewImages"
                :disabled="!valid"
                @open="showPdf"
              />
            </div>
            </template>
        </v-section-panel>

        <!-- 確定ボタン -->
        <v-btn color="gray" to="/teacher/result">プレビュー画面へ戻る</v-btn>
        <!-- 途中保存 -->
        <v-save-button
          :save-fnc="save"
          :disabled="!valid"
        />
        <!-- プレビュー更新ボタン -->
        <v-btn
          class="ml-3"
          color="#4989d1"
          style="color: white;"
          @click="previewAllUpdate()"
        >
          プレビュー更新
        </v-btn>
        <v-btn color="secondary" class="ml-3" @click="toRegistExam()" :disabled="!valid">次へ</v-btn>
      </template>
    </v-base-card>

    <!-- 合計100点over時のアラート -->
    <transition name="slide-right">
      <v-attention-area type="alert" float class="alert" v-if="totalScoreError">
        <template slot="content">
        <p class="mb-0" style="font-weight:bold">{{totalScoreError}}</p>
        </template>
      </v-attention-area>
    </transition>

    <v-dialog
      v-model="dialog"
      max-width="50%"
    >
      <v-card class="pa-3" ref="dialog" :min-height="$refs.dialog ? $refs.dialog.$el.clientHeight : ''">
        <v-img
          ref="dialog-image"
          :height="dialogImageHeight"
          contain
          :src="showedImage"
        />
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            dark
            @click.stop="changeDialogImage"
          >
            {{dialogImage === 'question' ? '解答' : '問題'}}
          </v-btn>

          <v-btn
            color="green darken-1"
            dark
            @click="dialog = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSectionPanel from '@/components/molecules/SectionPanel'
import VResultTable from '@/components/molecules/ResultTable'
import VStepp from '@/components/molecules/Stepp'
import VBarCharts from '@/components/organizms/BarCharts'
import VPreviewButtons from '@/components/molecules/PreviewButtons'
import VSaveButton from '@/components/molecules/SaveButton'
import VAttentionArea from '@/components/molecules/AttentionArea'
import config from "../../config"
import { convertHalf, isChangeNumber } from '../../plugins/form-check'
import { getStepCols } from '../../plugins/responsive'

export default {
  components: {
    VBaseCard,
    VSectionPanel,
    VResultTable,
    VStepp,
    VBarCharts,
    VPreviewButtons,
    VSaveButton,
    VAttentionArea
  },

  data: () => ({
    tab: 'One',
    dialog: false,
    dialogImageHeight: '',
    dialogImage: null,
    showedImage: null,
    dialogQuestionImage: require('@/assets/img/part_q_1.png'), //TODO:組版連携後、生成された画像を表示する
    dialogAnswerImage: require('@/assets/img/part_an_1.png'),
    stepps: [
      {no: 1, text: '問題差し替え', to: '/teacher/change', complete: true, editable: false},
      {no: 2, text: 'プレビュー', to: '/teacher/result', complete: true, editable: false},
      {no: 3, text: '配点設定', to: '/teacher/score_setting', complete: false, editable: false},
      {no: 4, text: 'テスト登録', to: '/teacher/regist_exam', complete: false, editable: false},
    ],
    targetQuestionIndex: 0,
    previewImages: null,
    convertHalf:convertHalf,
    isChangeNumber:isChangeNumber,
    stepCols: getStepCols()
  }),

  async mounted() {
    const targetSheetId = this.$store.state.sheet.sheetContentPages.id
    const params = {
      sheet: {
        step: config.step.SCORE_SETTING,
      }
    }
    await this.$axios.put('/api/v1/teacher/sheets/' + targetSheetId, params)
  },

  methods: {
    async save() {
      // 途中保存処理
      const params = {
        sheet: {
          sheet_content_pages_attributes: this.usedItems.map(sheetContentPage => {
            return {                                                        //大問内容の配列
              id:               sheetContentPage.sheetContentPageId,          //sheet_content_page_id
              content_page_id:  sheetContentPage.contentPageId,               //content_page_id
              number:           sheetContentPage.number,                      //大問並び順
              sheet_questions_attributes:  sheetContentPage.sheetQuestions.map((question) => {
                return {                                                       //小問内容の配列（今回設定した配点や観点を登録する）
                  id:             question.id,                                   //sheet_questions_id
                  number:         question.number,                               //小問並び順
                  allot:          question.allot,                                //配点
                  point_id:       question.pointId,                              //観点ID
                  question_id:    question.questionId,                           //小問ID
                }
              })
            }
          }),
          step: config.step.SCORE_SETTING,
          search_conditions: this.$store.state.sheet.sheetSearchCondition
        },
      }
      //途中保存処理
      await this.$store.dispatch('sheet/updateSheetStatus', params)
    },

    updateScore(value) {
      var changeValue = convertHalf(value)
      if (isChangeNumber(changeValue)) changeValue = Number(changeValue)

      // 配点の変更を反映する
      this.$store.commit('sheet/setChangedItems', {
        changedAllot:        changeValue,            // 変更後の観点(文字列で入力されているので数値に変換)
        targetItemIndex:     this.tab,                 // 対象大問index番号(現在選択中のタブから取得)
        targetQuestionIndex: this.targetQuestionIndex, // 対象小問index番号(v-selectのonChangeで取得)
        mode:                'score'                   // 観点と共有のmitationを使用する
      })
      this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
    },

    updatePointId(value) {
      // 観点の変更を反映する
      this.$store.commit('sheet/setChangedItems', {
        changedPointId:      value,                    // 変更後の観点
        targetItemIndex:     this.tab,                 // 対象大問index番号(現在選択中のタブから取得)
        targetQuestionIndex: this.targetQuestionIndex, // 対象小問index番号(v-selectのonChangeで取得)
        mode:                'viewPoint'               // 配点と共有のmitationを使用する
      })
      this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
    },

    showDialog() {
      this.dialog = !this.dialog;
      this.dialogImage = 'question';
      this.showedImage = this.selectedItem.questionImage;
    },

    changeDialogImage() {
      this.dialogImage = this.dialogImage === 'question' ? 'answer' : 'question';
      this.showedImage = this.dialogImage === 'question' ? this.selectedItem.questionImage : this.selectedItem.answerImage;
      if (this.dialogImage === 'answer') {
        this.dialogImageHeight = this.$refs['dialog-image'].$el.clientHeight
      }
    },
    setTargetQuestionIndex(targetQuestionIndex) {
      // 配点や観点の変更された小問index番号を取得
      this.targetQuestionIndex = targetQuestionIndex
    },

    async previewAllUpdate() {
      // 強制的に更新するためにisUpdateをtrueにする
      this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
      this.showPdf('all')
    },

    async showPdf(mode){
      this.$app.$refs.loading.open({type: 'print', message: 'プレビュー作成中'})
      this.previewImages = null
      const isUpdate = this.$store.state.sheet.isUpdate[mode]
      if(isUpdate){
        await this.save()
      }
      await this.$store.dispatch('sheet/getSheetImages', {params:{type:mode}})
      const questionFilePaths = this.$store.state.sheet.questionImages
      const answerFilePaths = this.$store.state.sheet.answerImages
      this.previewImages = this.makePreviewImages({ questionFilePaths, answerFilePaths })
      this.$app.$refs.loading.close({})
    },

    makePreviewImages(imagePaths){
      var { questionFilePaths, answerFilePaths } = imagePaths
      questionFilePaths = questionFilePaths ?? []
      answerFilePaths = answerFilePaths ?? []
      const baseURL = this.$axios.defaults.baseURL
      return {
        question: {
          name: '問題',
          data: questionFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200 } })
        },
        answer: {
          name: '解答',
          data: answerFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200 } })
        },
      }
    },

    async toRegistExam(){
      await this.save()
      //PDFダウンロードフラグはリロード対応としてstoreで管理
      this.$store.commit('sheet/setPdfDlFlg', { pdfDlFlg: false })
      this.$router.push('/teacher/regist_exam')
    },

    selectContentScore(itemIndex){
      if (!this.contentTotalScores || !this.selectedItem) return {}
      const target = this.contentTotalScores.find((el,index) => index === itemIndex)
      return target || {}
    },

    createQuestionNo(question) {
      let questionNo = String(question.number)
      if (question.sub_number) questionNo += `-${question.sub_number}`
      return questionNo
    },

    setStepCols() {
      this.stepCols = getStepCols()
    }

  },
  computed: {
    usedItems() {
      return this.$store.state.sheet.usedItems
    },
    selectedMaxPoint(){
      return this.$store.state.top.selectedMaxPoint
    },
    viewPoints() {
      // セレクトボックス用にマスタデータ取得
      return this.$store.state.master.allPoints.map(point => {
        return {
          id:   point.id,
          name: point.name
        }
      })
    },
    contentTotalScores() {
      // 大問単位に集計した配点を取得
      return this.$store.getters['sheet/contentTotalScores']
    },

    totalScore() {
      // 各大問の合計点から総合計点を算出
      return this.contentTotalScores.reduce((total, contentTotalScore) => {
        total += contentTotalScore.totalScore
        return total
      }, 0)
    },

    totalScoreError(){
      if (this.totalScore == this.selectedMaxPoint) return
      return '合計点が' + this.selectedMaxPoint + '点' + (this.totalScore > this.selectedMaxPoint ? 'を超過しています。' : '未満です。')
    },

    selectedItem(){
      if (!(typeof this.tab === 'number') || !(isFinite(this.tab))) return {}
      return this.usedItems[this.tab]
    },

    numberErrors(){
      if (!this.contentTotalScores) return
      var errors = []
      var nullError = '空欄です'
      var notNumberError = '数字だけで入力してください'
      var zeroError = '0点です'
      this.contentTotalScores.forEach(content => {
        content.itemTotalScores.forEach (item => {
          const baseError = `大問${content.sortNo}の小問${item.sortNo}`
          if (item.allot == 0) errors.push(baseError + 'が' + zeroError)
          else if (item.allot === '' || !item.allot) errors.push(baseError + 'が' + nullError)
          else if (!isChangeNumber(item.allot)) errors.push(baseError + 'は' + notNumberError)
        })
      })
      return errors
    },

    valid(){
      return this.numberErrors.length == 0 && !this.totalScoreError
    }
  }
}
</script>

<style lang="stylus" scoped>
.result-btn
  margin-right 10px

.result-score
  float right

.change-heading
  display inline-block

  &__text
    display inline-block

.score
  width 160px
  &__area
    width 125px
    display inline-block
  &__input
    width 95px
    display inline-block
    margin-right 5px
  &__question-cnt
    margin-bottom 0px
    display inline-block

.viewpoint
  width 260px
  min-width 260px
  div
    font-size 14px !important

.part-total
  font-weight bold

  &__value
    font-size 16px

.part-num
  vertical-align top
  padding-top 16px !important

.card
  position relative

  &-image
    position absolute
    top 50%
    left 50%
    transform translateY(-50%) translateX(-50%)

.attention
  font-size 13px

.attention-number-errors
  color:#FF0000;
  font-weight:bold;

.alert
  width 89.3%
  position fixed
  top 80px
  z-index 10

.question_no
  min-width 50px

.buttons
  display flex
</style>
